const themeContract = {
  argos: {
    button: {
      background: 'brand-1',
      borderColor: 'brand-1',
      color: 'white',
      colorActive: 'black'
    }
  },
  habitat: {
    button: {
      background: 'brand-1',
      borderColor: 'brand-1',
      color: 'white',
      colorActive: 'brand-1'
    }
  },
  tuOnArgos: {
    button: {
      background: 'grey-90',
      borderColor: 'grey-90',
      color: 'white',
      colorActive: 'grey-90'
    }
  }
}

export { themeContract }
